import request from '@/utils/request'

//查询客户端订单管理信息
export const orderData = (params) => {
    return request({
        url: '/hqprotal/orderManage/clientOrderInformation',
        method: 'get',
        params
    })
}

//根据客户账号查询客户公司信息
export const selectPlantByUserName = (data) => {
    return request({
        url: '/hqprotal/manage/selectPlantByUserName',
        method: 'post',
        data
    })
}

//工厂的信息
export const selectClientByUserName = (data) => {
    return request({
        url: '/hqprotal/information/selectClientByUserName',
        method: 'post',
        data
    })
}

//获取生产商订单管理详细信息
export const plantOrderData = (params) => {
    return request({
        url: '/hqprotal/orderManage/plantOrderInformation',
        method: 'get',
        params
    })
}
